'use strict';
import React, { Component } from 'react';

class PantallaPrincipalAtlas extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="Atlas__logo">
            </div>
        );
    }
}

export default PantallaPrincipalAtlas;